export default __webpack_public_path__ + "static/media/question.52b43b14.svg";